var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1372_11977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.34235 8.23789C7.36322 8.23789 8.18136 9.06399 8.18136 10.0921V12.5603C8.18136 13.5812 7.36322 14.4138 6.34235 14.4138L3.89516 14.4138C2.88153 14.4138 2.05615 13.5812 2.05615 12.5603L2.05615 10.0921C2.05615 9.06399 2.88153 8.23789 3.89516 8.23789L6.34235 8.23789ZM14.6976 8.23789C15.7112 8.23789 16.5366 9.06399 16.5366 10.0921L16.5366 12.5603C16.5366 13.5812 15.7112 14.4138 14.6976 14.4138L12.2504 14.4138C11.2296 14.4138 10.4114 13.5812 10.4114 12.5603L10.4114 10.0921C10.4114 9.06399 11.2296 8.23789 12.2504 8.23789L14.6976 8.23789ZM6.34235 -0.0664062C7.36322 -0.0664062 8.18136 0.766217 8.18136 1.78781V4.25599C8.18136 5.2841 7.36322 6.10948 6.34235 6.10948L3.89516 6.10948C2.88153 6.10948 2.05615 5.2841 2.05615 4.25599L2.05615 1.78781C2.05615 0.766217 2.88153 -0.0664062 3.89516 -0.0664062L6.34235 -0.0664062ZM14.6976 -0.0664062C15.7112 -0.0664062 16.5366 0.766217 16.5366 1.78781V4.25599C16.5366 5.2841 15.7112 6.10948 14.6976 6.10948H12.2504C11.2296 6.10948 10.4114 5.2841 10.4114 4.25599L10.4114 1.78781C10.4114 0.766217 11.2296 -0.0664062 12.2504 -0.0664062L14.6976 -0.0664062Z",
    fill: "#B6BDC3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1372_11977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5664,
    height: 15.5664,
    fill: "white",
    transform: "translate(0.759277 0.222656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInActive);
export default __webpack_public_path__ + "static/media/DashboardInActive.e1cb1141df3a104bf8f294e433b94891.svg";
export { ForwardRef as ReactComponent };